import { FC, useState } from 'react';

import { useForgotPassword } from '@modules/auth/queries/use-forgot-password';
import { useAuthStore } from '@modules/auth/store/auth-store';

import { ForgotPasswordInitial } from './ForgotPasswordInitial';
import { ForgotPasswordSuccess } from './ForgotPasswordSuccess';

import type { ForgotPasswordMutationResult } from './types';

const ForgotPassword: FC = () => {
  const [forceSuccess, setForceSuccess] = useState(false);
  const { userInfo } = useAuthStore();

  const mutation = useForgotPassword() as ForgotPasswordMutationResult;

  if (mutation.isSuccess || forceSuccess) {
    const email = userInfo?.email;

    return (
      <ForgotPasswordSuccess
        resend={mutation.mutate}
        email={email}
        setForceSuccess={setForceSuccess}
      />
    );
  }
  return (
    <ForgotPasswordInitial mutation={mutation} forceSuccess={setForceSuccess} />
  );
};

export { ForgotPassword };
